import { render, staticRenderFns } from "./AlipayPoints.vue?vue&type=template&id=6713d543&scoped=true"
import script from "./AlipayPoints.vue?vue&type=script&lang=js"
export * from "./AlipayPoints.vue?vue&type=script&lang=js"
import style0 from "./AlipayPoints.vue?vue&type=style&index=0&id=6713d543&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6713d543",
  null
  
)

export default component.exports